import { createContext } from 'react'

import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { GQLProfileQuery } from 'components/page/Profile/gql/__generated__/Profile'
import { Position } from 'components/presentational/Tooltip/Tooltip.types'
import { GQLGender } from 'generated-graphql/graphql'

export type ProfileContextValue = {
  profileId: number
  isEditable: boolean
  gender: GQLGender
  teamo?: {
    currentUser: GQLProfileQuery['my']['teamo']
    foreignUser: NonNullable<GQLForeignRootQuery['user']>['teamo']
  } | null
  countryId?: string | null
}

export const ProfileContext = createContext<ProfileContextValue>({
  profileId: 0,
  isEditable: false,
  gender: GQLGender.M,
  teamo: null,
})

export const ProfileTooltipContext = createContext<{
  position: Position
  zIndex?: number
}>({
  position: Position.BottomLeft,
})
